import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'

export default function Create() {
	
	const navigate  = useNavigate();

	const [hunterId, setHunterId] = useState('');
	const [punishmenttypeId, setPunishmentTypeId] = useState('');
	const [datum, setDatum] = useState('');
	const [opis, setOpis] = useState('');
	const [napomena, setNapomena] = useState('');

	
	useEffect(() => {
        setHunterId(localStorage.getItem('hunterId'))
	}, []);
	
	const updateAPIData = () => {
		axios.post(`http://89.46.196.228:3000/api/punishments`,
			{
				"hunterId": hunterId,
				"punishmenttypeId": punishmenttypeId,
				"datum": datum,
				"opis": opis,
				"napomena": napomena
			}
			).then(() => {
				
            navigate('/dashboard/SLOBiHClanovi')
			
        })
    }

    return (
	    <div className="main">
        <div>
            <Form className="create-form">
			
				<Form.Field>
                    <Label>Hunter Id</Label>
                    <input placeholder='Hunter Id' value={hunterId} onChange={(e) => setHunterId(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Vrsta</Label>
                    <input placeholder='Vrsta' value={punishmenttypeId} onChange={(e) => setPunishmentTypeId(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Datum</Label>
                    <input placeholder='Datum' value={datum} onChange={(e) => setDatum(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Opis</Label>
                    <input placeholder='opis' value={opis} onChange={(e) => setOpis(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Napomena</Label>
                    <input placeholder='Napomena' value={napomena} onChange={(e) => setNapomena(e.target.value)}/>
                </Form.Field>
				
                <Button onClick={updateAPIData} type='submit'>Submit</Button>
				
            </Form>
        </div>
		</div>
    )
}